module.exports = __WEBPACK_EXTERNAL_MODULE_280__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/errors/EOFError","root":["openfl","errors","EOFError"],"commonjs":"openfl/errors/EOFError","commonjs2":"openfl/errors/EOFError"}
// module id = 280
// module chunks = 0